<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Understanding Your Case for Support</h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">
                Your Case for Support is a comprehensive narrative that explains why your organization exists, what it aims to achieve, and how supporters can help you get there. It provides the rationale for giving—making a compelling argument rooted in your mission, impact, and financial needs. In this section, you'll define the key components of your case, such as your vision, programs, budget, and outcomes, and learn how to align them into a clear, inspiring message that can be adapted for different audiences.
            </p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 